export const originFlowActivityType = [
    {id:"5929f816-89c5-4828-9ea3-4ff54be008e3", name:"Echometer"},
    {id:"63624ddd-41c7-45df-8d12-805eb644268c", name:"Leutert Digital"}
]